import { styled } from '@mui/material/styles';

import { Button as SharedButton } from 'shared/components/buttons/Button';

export const Button = styled(SharedButton)(({ theme }) => ({
  borderRadius: '24px',
  // TODO: change to variable from theme
  color: theme.palette.common.white,
  borderColor: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
  },
})) as typeof SharedButton;
